module.exports = __webpack_public_path__ + "img/create.59e2bf87.png";